'use client'

import { HTMLAttributes } from 'react'
import { getPdfExtractError } from '@/app/constants/loanPdfExtract'

interface Props {
    code: string | null
    rootProps: HTMLAttributes<HTMLDivElement>
    onRetry: () => void
}

export default function LoanPdfExtractError({ code, rootProps, onRetry }: Props) {
    const { title, body, canRetry } = getPdfExtractError(code || undefined)

    return (
        <div
            {...rootProps}
            data-test="pdf-extract-error"
            role="alert"
            aria-live="assertive"
            className="rounded-2xl border border-dashed border-red-300 bg-red-100 p-5 text-center md:p-8"
        >
            <span className="mx-auto flex size-12 items-center justify-center rounded-full bg-red-900 text-lg text-white">
                <i className="fa-regular fa-cloud-arrow-up" />
            </span>

            <p
                style={{ fontFamily: 'var(--font-recoleta)' }}
                className="m-0 mt-3 text-[17px] font-bold text-red-900 md:text-[19px]"
            >
                {title}
            </p>
            <p className="m-0 mt-1 text-[14px] text-red-800">{body}</p>

            {canRetry && (
                <button
                    type="button"
                    onClick={onRetry}
                    data-test="pdf-extract-retry"
                    className="mt-4 inline-flex items-center justify-center gap-2 rounded-xl border border-rm-orange bg-white px-6 py-3 text-[15px] font-bold text-rm-orange"
                >
                    <i className="fa-regular fa-rotate-right" />
                    Réessayer
                </button>
            )}
        </div>
    )
}
